<template>
    <div data-testid="manual-banking-warning" role="alert" class="bg-yellow-50 border border-yellow-200 text-yellow-800 rounded-lg p-3 text-sm text-left">
        <span class="font-semibold">We don't support manual banking connections for now.</span>
        Please connect your bank via Plaid or
        <a v-if="supportEmail" :href="'mailto:' + supportEmail" class="underline font-semibold" data-testid="manual-banking-warning-support">contact support</a>
        <template v-else>contact support</template>
        if you have any questions.
    </div>
</template>

<script>
/**
 * Fixed notice shown next to every borrower "Manual" bank option and at the top of every manual bank
 * form while manual banking connections are unsupported (#7094 follow-up: paystub checks and IntroXL
 * missed-payment refreshes need a Plaid banking user). Copy is intentionally hard-coded: removing the
 * notice later means deleting this component and its five usages.
 */
export default {
    name: 'ManualBankingWarning',

    computed: {
        supportEmail() {
            return window.support_email || '';
        },
    },
};
</script>
